<template>
    <div class="box_develop_phone">

        <Timeline>
            <TimelineItem v-for="(develop, index) in developCont" :key="index">
                <p class="time">{{develop.years}}</p>
                <pre class="content">{{develop.affair}}</pre>
            </TimelineItem>

        </Timeline>

    </div>
</template>

<script>

    export default {
        name: "swiperDevelop",
        components: {},
        data() {
            return {
                developCont: [
                    {
                        affair:'*盛大天地·全球研发中心项目启动',
                        years:'2008',
                    },
                    {
                        affair:'*盛大天地·盛创中心产业改造升级',
                        years:'2010',
                    },
                    {
                        affair:'*盛大天地·全球研发中心项目开园',
                        years:'2012',
                    },
                    {
                        affair:'*Evergreen Center硅谷项目改造升级',
                        years:'2013',
                    },
                    {
                        affair:'*盛大天地·微电子港1号旧改升级\n*盛大天地·盛贸中心项目启动',
                        years:'2014',
                    },
                    {
                        affair:'*青春里公寓·金科路（一期）正式交付' +'\n'+
                            '*青春里公寓·居里路正式交付' +'\n'+
                            '*首届张江青年运动会成功举办' +'\n'+
                            '*青云社（张江青年人才社群）成立',
                        years:'2015',
                    },
                    {
                        affair:'*盛大天地·源创谷开园',
                        years:'2016',
                    },
                    // {
                    //     affair:`*盛大天地·盛创中心翻改建\n*静阳庄开发建设`,
                    //     years:'2017',
                    // },
                    {
                        affair:'*盛大天地·盛贸中心开园' +'\n'+
                            '*青春里公寓·金科路（二期）正式交付'+'\n'+
                            '*静阳庄东京项目改造升级\n*张江盛腾天地项目交付',
                        years:'2017',
                    },
                    {
                        affair:'*盛大天地创新型孵化器揭牌',
                        years:'2018',
                    },
                    {
                        affair:'*星享汇（泛科创企业联盟）成立',
                        years:'2019',
                    },
                    {
                        affair:'*盛大天地·盛贸中心专业型孵化器揭牌',
                        years:'2020',
                    },
                    {
                        affair:'*提出“构建盛大天地长三角产业生态圈”\n*盛大天地·南通创新中心项目启动',
                        years:'2021',
                    },
                    {
                        affair:'*发起成立上海市工商联房地产商会\n 智慧产业园专委会',
                        years:'2022',
                    },
                ],
                swiperDevelop: {
                    autoplay: 3000,
                    slidesPerView : 6,
                    slidesPerGroup : 1,
                    spaceBetween: 0,
                    initialSlide :4,
                    // loop: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides : true,
                    // observer: true,
                    // observeParents: true,
                    // loopFillGroupWithBlank: true,
                    // effect: 'fade',

                    /*


                    pagination: '.swiper-pagination',
                    observer: true,
                    observeParents: true,
                    initialSlide: 4,
                    grabCursor: true // 抓手*/
                },
                loading: false,
            };
        },
        methods: {},
        mounted() {
        },
    }
</script>

<style lang="less">
    .box_develop_phone {
        padding:20px 50px;
        .ivu-timeline-item-tail{
            border-left-color:#3DB4FF;
        }
        .ivu-timeline-item-head{
            background-color: #3DB4FF;
            border-color:#3DB4FF
        }
        .time{
            font-size: 14px;
            font-weight: bold;
        }
        .content{
            padding-left: 5px;
        }
    }
</style>